<template>
  <v-container fluid>
    <div v-if="assetListid == ''">
      <page-bar title="Asset Lists">
        <template v-slot:actions>
          <v-btn
            color="green"
            dark
            class="ma-0"
            v-on:click="OnCreateNewAssetList()"
            v-if="CanUserEditAssets()"
          >
            <v-icon left>mdi-plus</v-icon>
            Create New List
          </v-btn>
        </template>
      </page-bar>

      <div class="px-8 py-4">
        <div class="mb-4">
          <v-card class="elevation-1" color="primaryDark" dark tile>
            <v-card-text class="pa-4">
              <grid-system
                :columns="{ xs: 1, sm: 2, md: 3 }"
                :gap="12"
                :alignItems="'center'"
              >
                <div>
                  <v-select
                    class="mt-0 theme-dark"
                    v-model="filteredTeams"
                    label="Filter by Team"
                    hide-details
                    :items="teams"
                    item-text="teamName"
                    item-value="id"
                    dense
                    multiple
                    clearable
                    :menu-props="{ light: true }"
                    v-on:change="ClearSearchResults()"
                  />
                </div>
                <div>
                  <v-text-field
                    class="mt-0"
                    label="Search"
                    dense
                    hide-details
                  />
                </div>
              </grid-system>
            </v-card-text>
          </v-card>
        </div>

        <div class="subtitle-1 font-weight-bold mt-6 mb-2 white--text">
          Results
        </div>

        <grid-system :columns="{ xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }" :gap="16">
          <div v-for="(assetList, index) in searchResults.results" :key="index">
            <asset-list-card
              :assetList="assetList"
              style="min-height:225px;"
              v-on:click="OnAssetListClick(assetList.id)"
            />
          </div>
        </grid-system>

        <div class="mt-4">
          <infinite-loading
            v-if="initalLoadLoaded"
            :identifier="infiniteIncrementor"
            @infinite="infiniteHandler"
          >
            <div slot="spinner">Loading...</div>
            <div slot="no-more"></div>
            <div slot="no-results"></div>
          </infinite-loading>
        </div>
      </div>
    </div>
    <div v-else-if="assetList != null">
      <div class="px-8 py-4">
        <v-row>
          <v-col cols="2">
            <v-row no-gutters="">
              <v-btn dark="" v-on:click="OnBack()" class="ma-0 mb-1" block>
                Back
              </v-btn>
            </v-row>
            <v-row no-gutters="">
              <v-card width="100%" height="140px" color="transparent">
                <v-img
                  height="100%"
                  contain=""
                  :src="
                    assetList.thmUrl != null
                      ? assetList.thmUrl
                      : 'https://activstoredev.blob.core.windows.net/test/box.png'
                  "
                >
                  <v-btn
                    v-on:click="imageUploadDialog = true"
                    v-if="userCanEdit"
                    class="ma-0"
                    icon=""
                    fab=""
                    small
                    style="bottom:0;top:auto;right:0;position:absolute;"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-img>
              </v-card>
            </v-row>
          </v-col>
          <v-col class="pa-0">
            <v-row no-gutters="">
              <v-col class="pa-0" cols="auto" align-self="center">
                <TextEditor
                  class="title"
                  :value="assetList.name"
                  v-on:onEdit="OnAssetListTextChange"
                  v-bind:forcedEdit="editingAssetListTitle"
                >
                </TextEditor>
              </v-col>
              <v-col
                class="pa-0"
                cols="auto"
                align-self="center"
                v-if="CanUserEditAssets()"
              >
                <v-btn
                  :color="editingAssetListTitle ? 'orange' : ''"
                  class="ma-0 ml-1"
                  icon=""
                  v-on:click="editingAssetListTitle = !editingAssetListTitle"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </v-col>
              <v-spacer />
              <v-col class="pa-0" cols="auto" align-self="center">
                <v-btn
                  class="ma-1"
                  width="200px"
                  color="black"
                  dark
                  v-on:click="onTapGetPDFForAssetList()"
                  :loading="downloadingPDF"
                >
                  <v-icon left>
                    mdi-file-pdf
                  </v-icon>
                  Download as PDF
                </v-btn>
              </v-col>
              <v-col class="pa-0" cols="auto" align-self="center">
                <v-btn
                  class="ma-1"
                  width="160px"
                  v-if="userCanEdit && assetListIsDirty"
                  color="green"
                  dark
                  v-on:click="OnSaveChanges"
                >
                  <v-icon left>
                    mdi-upload
                  </v-icon>
                  Save Changes
                </v-btn>
              </v-col>
              <v-col class="pa-0" cols="auto" align-self="center">
                <v-btn
                  class="ma-1"
                  width="180px"
                  v-if="userCanEdit && selectedAssets.length > 0"
                  v-on:click="OnRemoveSelection"
                  color="black"
                  dark
                >
                  <v-icon left>
                    mdi-delete
                  </v-icon>
                  Delete Selected
                </v-btn>
              </v-col>
              <v-col class="pa-0" cols="auto" align-self="center">
                <v-btn
                  class="ma-1"
                  width="110px"
                  v-if="userCanEdit"
                  color="black"
                  dark
                  v-on:click="OnEditAssetList()"
                >
                  <v-icon class="mr-1" left>
                    mdi-pencil
                  </v-icon>
                  Edit
                </v-btn>
              </v-col>
              <v-col class="pa-0" cols="auto" align-self="center">
                <v-btn
                  class="ma-1"
                  width="190px"
                  v-if="userCanEdit"
                  color="red"
                  dark
                  v-on:click="OnDeleteAssetList()"
                >
                  <v-icon left>
                    mdi-delete
                  </v-icon>
                  Delete Asset List
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  label="Allocated Teams"
                  multiple
                  :items="teams"
                  :item-text="'teamName'"
                  :item-value="'id'"
                  v-model="selectedTeams"
                  v-on:change="OnAssetListTeamsChange"
                  chips
                  deletable-chips
                  :clearable="CanUserEditAssets()"
                  outlined
                  dense
                  :disabled="!CanUserEditAssets()"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <span class="title ml-1">Assets in asset list</span>
          <v-divider></v-divider>
        </v-row>
        <v-row>
          <v-col
            class="pa-1"
            cols="2"
            v-for="(asset, i) in assetSearchResults.results"
            :key="i"
          >
            <asset-card
              :showDelete="userCanEdit"
              :showSelect="userCanEdit"
              :asset="asset"
              v-on:click="OnAssetListClick('test')"
              v-on:AssetSelected="OnAssetSelected"
              :selected="selectedAssets.indexOf(asset.id) > -1"
              v-on:onDelete="OnRemoveAsset"
              :imageHeight="100"
            >
            </asset-card>
          </v-col>
          <v-card height="40px" width="100px" color="transparent" flat>
            <infinite-loading
              v-if="initalLoadLoaded"
              :identifier="infiniteAssetIncrementor"
              @infinite="infiniteAssetHandler"
            >
              <div slot="spinner">Loading...</div>
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </v-card>
        </v-row>
      </div>
    </div>
    <v-dialog
      v-model="imageUploadDialog"
      max-width="800px"
      v-if="CanUserEditAssets()"
    >
      <v-card class="pa-2">
        <v-card-title>
          <span class="headline">Upload Asset List Thumbnail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4" class="pa-1" justify="center" align="center">
                <v-card height="190px" class="justify-center">
                  <v-img
                    max-height="190px"
                    contain
                    :src="files.length ? files[0].thumb : ''"
                  />
                </v-card>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-card
                  class="upload"
                  color="transparent"
                  min-height="200px"
                  flat
                >
                  <v-simple-table v-if="files.length">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">File Name</th>
                          <th class="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(file, index) in files" :key="file.id">
                          <td>{{ file.name }}</td>
                          <td>
                            <v-btn
                              class="icon-btn"
                              color="red"
                              icon
                              @click="files.splice(index, 1)"
                            >
                              <v-icon>mdi-file-remove</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <v-container class="fill-height pa-4" fluid>
                    <v-row justify="center" align="center">
                      <v-btn>
                        <label
                          for="file"
                          class="btn btn-lg btn-primary"
                          style=""
                        >
                          Drop or Select Files
                        </label>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row justify="center" style="margin: 0px">
            <v-btn color="blue darken-1" text @click="imageUploadDialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="Upload()">
              <v-icon
                v-if="$refs.upload && this.$refs.upload.uploading"
                size="28"
                color="green"
                dark
              >
                mdi-loading mdi-spin
              </v-icon>
              <span v-else>Upload</span>
            </v-btn>
          </v-row>
        </v-card-actions>
        <file-upload
          :post-action="postEndPoint"
          :headers="GetAuthHeaderObj()"
          :multiple="false"
          :drop="true"
          :drop-directory="true"
          :maximum="1"
          accept="image/*"
          @input-filter="inputFilter"
          v-model="files"
          ref="upload"
        ></file-upload>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import AssetCard from "../../cards/AssetCard";
import AssetListCard from "../../cards/AssetListCard";
import TextEditor from "../../shared/TextEditor";
import FileUpload from "vue-upload-component";
import CONFIG from "../../../appconfig.json";
import axios from "axios";
import PageBar from "../../shared/PageBar";
import GridSystem from "../../shared/GridSystem";

export default {
  name: "AssetList",
  components: {
    InfiniteLoading,
    AssetCard,
    AssetListCard,
    TextEditor,
    FileUpload,
    PageBar,
    GridSystem,
  },
  props: {
    //Name of section of assetlist
    sectionName: {
      default: "",
      type: String,
    },
    //id asset list id
    assetListid: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...mapState("assetxpstate", ["section", "assetList", "teams"]),
    userCanEdit() {
      return this.CanUserEditAssets();
    },
    postEndPoint() {
      if (this.assetList != null)
        return (
          CONFIG.platformEndpoints.assetxpapi +
          "section/uploadAssetListImage/" +
          this.assetList.id
        );
      else return "Invalid";
    },
    uploadComplete() {
      return Object.values(this.files).every((file) => file.success);
    },
  },
  mounted: function() {
    this.GetTeams().then(() => {
      this.GetSection(this.sectionName).then(() => {
        this.initalLoadLoaded = true;
        this.ClearSearchResults();
      });
    });
  },
  data: () => ({
    infiniteIncrementor: 0,
    infiniteAssetIncrementor: 0,
    performingSearch: false,
    searchResults: {
      results: [],
      token: "",
      hasNextPage: false,
    },
    assetSearchResults: {
      results: [],
      token: "",
      hasNextPage: false,
    },
    initalLoadLoaded: false,
    selectedAssets: [],
    assetListIsDirty: false,
    editingAssetListTitle: false,
    imageUploadDialog: false,
    files: [],
    selectedTeams: [],
    filteredTeams: [],
    downloadingPDF: false,
  }),
  methods: {
    ...mapGetters("authentication", ["CanUserEditAssets", "GetAuthHeaderObj"]),
    ...mapMutations("assetxpstate", [
      "LoadInventoryAssetList",
      "RemoveAssetFromCurrentAssetList",
      "ChangeCurrentAssetListName",
      "ChangeCurrentAssetListTeams",
    ]),

    ...mapActions("assetxpstate", [
      "GetSection",
      "SearchAssetLists",
      "SearchForAssetList",
      "SetAssetList",
      "SearchWithAssetList",
      "UpsertAssetList",
      "DeleteCurrentAssetList",
      "GetTeams",
      "DownloadPDFForAssetList",
    ]),

    onTapGetPDFForAssetList() {
      this.downloadingPDF = true;
      this.DownloadPDFForAssetList(this.assetList.id).then(() => {
        this.downloadingPDF = false;
      });
    },

    OnRemoveAsset(assetToRemove) {
      this.RemoveAssetFromCurrentAssetList(assetToRemove.id);

      for (let i = 0; i < this.assetSearchResults.results.length; i++) {
        const element = this.assetSearchResults.results[i];

        if (element.id == assetToRemove.id) {
          this.assetSearchResults.results.splice(i, 1);
          break;
        }
      }

      this.assetListIsDirty = true;
    },
    OnEditAssetList() {
      this.LoadInventoryAssetList(this.assetList);
    },
    OnDeleteAssetList() {
      this.DeleteCurrentAssetList().then(() => {
        this.$router.push("/section/" + this.sectionName + "/lists");
      });
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;

        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        newFile.thumb = "";

        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    Upload() {
      this.$refs.upload.active = true;
    },
    OnAssetListTeamsChange() {
      this.ChangeCurrentAssetListTeams(this.selectedTeams);
      this.assetListIsDirty = true;
    },
    OnAssetListTextChange(newText) {
      this.ChangeCurrentAssetListName(newText);
      this.assetListIsDirty = true;
    },
    OnBack() {
      this.$router.push("/section/" + this.sectionName + "/lists");
    },
    OnSaveChanges() {
      this.UpsertAssetList(this.assetList).then(() => {
        this.assetListIsDirty = false;
      });
    },
    OnRemoveSelection() {
      for (let i = 0; i < this.selectedAssets.length; i++) {
        const searchElement = this.selectedAssets[i];

        this.RemoveAssetFromCurrentAssetList(searchElement);

        for (let y = 0; y < this.assetSearchResults.results.length; y++) {
          const element = this.assetSearchResults.results[y];

          if (element.id == searchElement) {
            this.assetSearchResults.results.splice(y, 1);
            break;
          }
        }
      }

      this.assetListIsDirty = true;
      this.selectedAssets = [];
    },
    OnAssetListClick(assetListid) {
      this.$router.push("lists/" + assetListid);
    },
    OnAssetSelected(eventObj) {
      var listingid = eventObj.id;
      var value = eventObj.value;
      var index = this.selectedAssets.indexOf(listingid);

      //if asset is not selected but was previously in the selected list
      if (value === false && index >= 0) {
        this.selectedAssets.splice(index, 1);
      }

      //if asset is selected and is not already in the selected list
      if (value === true && index < 0) {
        this.selectedAssets.push(listingid);
      }
    },
    ClearSearchResults() {
      this.downloadingPDF = false;
      this.searchResults = {
        results: [],
        token: "",
        hasNextPage: false,
      };

      this.assetSearchResults = {
        results: [],
        token: "",
        hasNextPage: false,
      };

      this.infiniteIncrementor += 1;
      this.infiniteAssetIncrementor += 1;
      if (this.assetListid.length > 0) {
        this.SetAssetList(this.assetListid);
      }
    },
    OnCreateNewAssetList() {
      this.LoadInventoryAssetList({
        name: "New Asset List",
        specificAssets: [],
        sectionids: [this.section.id],
      });
    },
    infiniteHandler($state) {
      var searchParams = {
        token: this.searchResults.token,
        sectionsToSearch: [this.section.id],
        count: 24,
        teamFilters: this.filteredTeams,
      };

      this.performingSearch = true;
      this.SearchAssetLists(searchParams).then((responseData) => {
        this.searchResults.results = this.searchResults.results.concat(
          responseData.results
        );
        this.searchResults.token = responseData.token;
        this.searchResults.hasNextPage = responseData.hasNextPage;
        this.performingSearch = false;
        if (this.searchResults.hasNextPage) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    infiniteAssetHandler($state) {
      var searchParams = {
        token: this.assetSearchResults.token,
        list: this.assetList,
        commit: false,
      };

      this.performingSearch = true;
      this.SearchWithAssetList(searchParams).then((responseData) => {
        this.assetSearchResults.results = this.assetSearchResults.results.concat(
          responseData.results
        );
        this.assetSearchResults.token = responseData.token;
        this.assetSearchResults.hasNextPage = responseData.hasNextPage;
        this.performingSearch = false;
        if (this.assetSearchResults.hasNextPage) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      this.selectedAssets = [];
      this.assetListIsDirty = false;
      this.ClearSearchResults();
    },
    uploadComplete(newValue) {
      if (newValue) {
        this.$router.go();
      }
    },
    assetList(newVal) {
      if (newVal != null) {
        this.selectedTeams = this.teams.filter((e) =>
          newVal.teams.includes(e.id)
        );
      }
    },
  },
};
</script>

<style></style>
